// Configuration de l'API
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://douane.vtymconsultinggroup.com/wp-json';
export const API_DOUANE_URL = process.env.REACT_APP_API_DOUANE_URL || 'https://douane.vtymconsultinggroup.com/wp-json/fd/v1';

// WordPress API
export const WP_API_URL = process.env.REACT_APP_WP_API_URL || 'https://douane.vtymconsultinggroup.com/wp-json/wp/v2';

// Autres configurations
export const APP_NAME = 'VTYM Consulting Group';
export const APP_VERSION = '1.0.0';

// Configuration des endpoints
export const ENDPOINTS = {
    // Authentification
    LOGIN: '/jwt-auth/v1/token',
    REGISTER: '/wp/v2/users',

    // Formations (WordPress)
    FORMATIONS: '/wp/v2/formation',
    CHAPITRES: '/wp/v2/chapitre',
    ARTICLES: '/wp/v2/article_premium',

    // Paiements (Custom)
    PAYMENT_CREATE: '/fd/v1/payment/create',
    PAYMENT_ORANGE_QR: '/fd/v1/payment/orange-qr',
    PAYMENT_WAVE_QR: '/fd/v1/payment/wave-qr',
    PAYMENT_STATUS: '/fd/v1/payment',
    PAYMENT_BANK_INFO: '/fd/v1/payment/bank-info',

    // Progression
    PROGRESSION: '/fd/v1/progression',

    // Inscriptions
    INSCRIPTIONS: '/fd/v1/inscriptions',
};

// Configuration paiement
export const PAYMENT_METHODS = {
    ORANGE_MONEY: 'orange_money',
    WAVE: 'wave',
    VIREMENT: 'virement'
};